import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import EventsRepository from '../../../repositories/EventsRepository';
import EventsDataRepository from '../../../../data/repositories/EventsDataRepository';
import XCheckpointManager from '@/core/managers/xcheckpointManager';

export default function* execute(action: any): any {
  try {
    const { eventId } = action;
    XCheckpointManager.registerStart('Evento Anulacion');
    yield put({ type: Types.SET_EVENT_UNSUBSCRIBE_REQUEST });
    const eventsRepository: EventsRepository = new EventsDataRepository();
    const eventResponse = yield call(
      eventsRepository.setEventUnsubscribe,
      eventId
    );
    if (!eventResponse) {
      yield put({
        type: Types.SET_EVENT_UNSUBSCRIBE_FAILURE,
        error: true
      });
      XCheckpointManager.registerEnd('Evento Anulacion');
      return;
    }
    yield put({
      type: Types.SET_EVENT_UNSUBSCRIBE_SUCCESS,
      data: eventResponse
      // { "status": "OK", "data": "Inscripción anulada con exito", "message": "OK" }
    });
    XCheckpointManager.registerEnd('Evento Anulacion');
  } catch (error) {
    yield put({
      type: Types.SET_EVENT_UNSUBSCRIBE_FAILURE,
      error: 'Ocurrió un error al momento de anular suscripción al evento.'
    });
    XCheckpointManager.registerEnd('Evento Anulacion');
  }
}
